import React, { useEffect, useState, useRef } from "react";
import { DefaultLayout } from "../components/_layout";
import { motion } from "framer-motion";

const Title = "Home";

// Directly import components
import {
  MainSection,
  ApplySection,
  CoursesSection,
  FaqSection,
  BenefitSection,
} from "./../components/_pages/Homepage";
import siteData from "../_data";

// Sections configuration
const sections = [
  { id: "main-banner", Component: MainSection },
  { id: "benefit", Component: BenefitSection },
  { id: "apply", Component: ApplySection },
  { id: "course-banner", Component: CoursesSection },
  { id: "faqs", Component: FaqSection },
];

const Homepage = () => {
  const [visibleSections, setVisibleSections] = useState({});

  const observer = useRef(
    new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        setVisibleSections((prev) => ({
          ...prev,
          [entry.target.id]: entry.isIntersecting,
        }));
      });
    })
  );

  useEffect(() => {
    const elements = document.querySelectorAll(".section");
    elements.forEach((el) => observer.current.observe(el));

    return () => {
      elements.forEach((el) => observer.current.unobserve(el));
    };
  }, []);

  return (
    <DefaultLayout
      title={`${Title} | ${siteData.brand.name}`}
      description="Musa Institute for Academic and Skills Development"
    >
      <>
        {/* Sections */}
        {sections.map(({ id, Component }) => (
          <motion.div
            key={id}
            id={id}
            className="section" // Class for selecting with Intersection Observer
            initial={{ opacity: 0, y: -50 }} // Initial state for animation
            animate={{
              opacity: visibleSections[id] ? 1 : 0, // Animate opacity based on visibility
              y: visibleSections[id] ? 0 : 50, // Slide in/out effect
            }}
            exit={{ opacity: 0, y: -50 }} // Animate out state
            transition={{ duration: 0.5, ease: "easeInOut" }} // Control timing and easing
            style={{
              position: "relative",
              width: "100%",

              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Component />
          </motion.div>
        ))}
      </>
    </DefaultLayout>
  );
};

export default Homepage;
